import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import { 
  Container, 
  Grid, 
  Card, 
  CardContent, 
  Typography, 
  Box,
  Avatar
} from "@material-ui/core";
import { 
  Assignment as AssignmentIcon,
  LocalOffer as TagIcon,
  People as PeopleIcon,
  PauseCircleFilled as PauseIcon,
  Star as StarIcon,
  Assessment as AssessmentIcon,
  AttachMoney as AttachMoneyIcon
} from "@material-ui/icons";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    borderRadius: '16px',
    border: `1px solid ${theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'}`,
    boxShadow: theme.palette.type === 'light' ? '0 4px 20px rgba(0, 0, 0, 0.05)' : '0 4px 20px rgba(0, 0, 0, 0.2)',
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 30px rgba(101, 23, 171, 0.15)',
      borderColor: 'rgba(101, 23, 171, 0.3)',
    },
  },

  avatar: {
    width: 60,
    height: 60,
    backgroundColor: 'rgba(101, 23, 171, 0.1)',
    color: '#6517ab',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: 32,
  },
  cardTitle: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },

  cardDescription: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
  },

}));

const ReportsCentral = () => {
  const theme = useTheme();
  const classes = useStyles();

  const history = useHistory();

  const reports = [
    {
      title: "Relatório de Atendimentos",
      description: "Relatório detalhado de tickets, tempos de resposta e resolução.",
      icon: <AssignmentIcon className={classes.icon} />,
      path: "/reports",
      color: "#6517ab"
    },
    {
      title: "Chats em Tempo Real",
      description: "Acompanhe todos os chats que estão acontecendo agora.",
      icon: <AssessmentIcon className={classes.icon} />,
      path: "/moments",
      color: "#6517ab"
    },
    {
      title: "Distribuição de Tags",
      description: "Visualize a utilização de tags nos seus atendimentos.",
      icon: <TagIcon className={classes.icon} />,
      path: "/tags-report",
      color: "#6517ab"
    },
    {
      title: "Acessos de Usuários",
      description: "Histórico de login, logout e duração das sessões dos usuários.",
      icon: <PeopleIcon className={classes.icon} />,
      path: "/users-report",
      color: "#6517ab"
    },
    {
      title: "Pausas de Usuários",
      description: "Controle e visualize todas as pausas realizadas pela equipe.",
      icon: <PauseIcon className={classes.icon} />,
      path: "/pauses/report",
      color: "#6517ab"
    },
    {
      title: "Avaliações (NPS)",
      description: "Mensure a satisfação dos seus clientes e desempenho da equipe.",
      icon: <StarIcon className={classes.icon} />,
      path: "/ratings-report",
      color: "#6517ab"
    },
    {
      title: "Relatório de Receitas",
      description: "Visualize a receita gerada pelos atendimentos concluídos.",
      icon: <AttachMoneyIcon className={classes.icon} />,
      path: "/revenue-report",
      color: "#6517ab"
    }
  ];

  return (
    <MainContainer>
      <MainHeader>
        <Title>Central de Relatórios</Title>
      </MainHeader>
      <Container className={classes.container}>
        <Box mb={4}>
          <Typography variant="h6" style={{ color: theme.palette.text.secondary, fontWeight: 400 }}>
            Selecione um relatório abaixo para visualizar os dados detalhados.
          </Typography>

        </Box>
        <Grid container spacing={4}>
          {reports.map((report, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card 
                className={classes.card} 
                onClick={() => history.push(report.path)}
              >
                <CardContent>
                  <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    <Avatar className={classes.avatar}>
                      {report.icon}
                    </Avatar>
                    <Typography variant="h6" className={classes.cardTitle}>
                      {report.title}
                    </Typography>
                    <Typography variant="body2" className={classes.cardDescription}>
                      {report.description}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MainContainer>
  );
};

export default ReportsCentral;
